"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDisabledCopyButton = void 0;

var _useConstructorContextDispatch = require("./useConstructorContextDispatch");

var _react = require("react");

var _actions = require("../../../store/actions");

var useDisabledCopyButton = function useDisabledCopyButton() {
  var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var dispatch = (0, _useConstructorContextDispatch.useConstructorContextDispatch)();
  (0, _react.useEffect)(function () {
    if (!disabled) {
      return;
    }

    dispatch((0, _actions.changeCopyDisabled)(true));
  }, []);
};

exports.useDisabledCopyButton = useDisabledCopyButton;